import GroupButtons from "../../../ui/button/groupButtons";
import BaseStep from "./baseStep";
import { EDealRequestTimeInterval } from "./types";

interface ITimeIntervalStep {
  handlePrevStep: () => void;
  handleNexStep: () => void;
  onChange: (
    data: EDealRequestTimeInterval,
    key: "timeIntervalTypeView" | "timeIntervalTypeCommunication"
  ) => void;
  isNextStepDisabled: boolean;
  data: EDealRequestTimeInterval | null;
  mode: "view" | "communication";
  text: string;
}

const TimeIntervalStep = ({
  handlePrevStep,
  handleNexStep,
  onChange,
  isNextStepDisabled,
  data,
  mode,
  text,
}: ITimeIntervalStep) => {
  const handleChange = (data: EDealRequestTimeInterval) => {
    if (mode === "view") {
      onChange(data, "timeIntervalTypeView");
    } else {
      onChange(data, "timeIntervalTypeCommunication");
    }
  };

  return (
    <BaseStep
      prevStep={handlePrevStep}
      nextStep={handleNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text={text}
    >
      <GroupButtons
        data={[
          {
            onClick: () =>
              handleChange(EDealRequestTimeInterval.From9AMTo6PMWorkday),
            label: "Будни 09:00-18:00",
            variant:
              data === EDealRequestTimeInterval.From9AMTo6PMWorkday
                ? "dark"
                : "lightDark",
          },
          {
            onClick: () =>
              handleChange(EDealRequestTimeInterval.From6PMTo9PMWorkday),
            label: "Будни 18:00-21:00",
            variant:
              data === EDealRequestTimeInterval.From6PMTo9PMWorkday
                ? "dark"
                : "lightDark",
          },
          {
            onClick: () =>
              handleChange(EDealRequestTimeInterval.From11AMTo8PMWeekend),
            label: "Сб,Вс 11:00-20:00",
            variant:
              data === EDealRequestTimeInterval.From11AMTo8PMWeekend
                ? "dark"
                : "lightDark",
          },
          {
            onClick: () => handleChange(EDealRequestTimeInterval.AnyTime),
            label: "Любое время",
            variant:
              data === EDealRequestTimeInterval.AnyTime ? "dark" : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default TimeIntervalStep;
